import { render, staticRenderFns } from "./nvidia.vue?vue&type=template&id=401d231e&"
import script from "./nvidia.vue?vue&type=script&lang=js&"
export * from "./nvidia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports